/* eslint-disable indent */

// Функция для форматирования даты из YYYY-MM-DD в DD.MM.YYYY
const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
};

// Функция для форматирования времени из секунд в ЧЧ:ММ:СС
const formatTime = (seconds) => {
    if (!seconds && seconds !== 0) return '';
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};

export default function TableConfig() {
    return {
        columns: [
            {
                dataIndex: 'date_only',
                title: 'Дата',
                render: (cell) => formatDate(cell),
                sorter: (a, b) => new Date(a.date_only) - new Date(b.date_only),
                fixed: 'left',
                width: 120,
            },
            {
                dataIndex: 'avg_wait_time',
                title: 'Среднее время ожидания',
                render: (cell) => formatTime(cell),
                sorter: (a, b) => a.avg_wait_time - b.avg_wait_time,
                width: 180,
            },
            {
                dataIndex: 'max_wait_time',
                title: 'Максимальное время ожидания',
                render: (cell) => formatTime(cell),
                sorter: (a, b) => a.max_wait_time - b.max_wait_time,
                width: 200,
            },
            {
                dataIndex: 'avg_processing_time',
                title: 'Среднее время обслуживания',
                render: (cell) => formatTime(cell),
                sorter: (a, b) => a.avg_processing_time - b.avg_processing_time,
                width: 200,
            },
            {
                dataIndex: 'max_processing_time',
                title: 'Максимальное время обслуживания',
                render: (cell) => formatTime(cell),
                sorter: (a, b) => a.max_processing_time - b.max_processing_time,
                width: 220,
            },
            {
                dataIndex: 'human_operators_count',
                title: 'Количество сотрудников, осуществляющих очный прием в окнах',
                sorter: (a, b) => a.human_operators_count - b.human_operators_count,
                width: 200,
            },
            {
                dataIndex: 'avg_workstation_load',
                title: 'Средняя нагрузка на одно окно',
                sorter: (a, b) => a.avg_workstation_load - b.avg_workstation_load,
                width: 200,
            },
        ],
    };
}
